import { render, staticRenderFns } from "./ExpedienteTipo.vue?vue&type=template&id=3eb07713&"
import script from "./ExpedienteTipo.vue?vue&type=script&lang=js&"
export * from "./ExpedienteTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports